'use strict';

class CustomFieldEdit {
  constructor($location, recipientService, Notification) {
    this.$location = $location;
    this.recipientService = recipientService;
    this.Notification = Notification;
  }

  $onInit() {
    this.recipientNumber = this.$location.search().number;

    this.field = {
      name: null,
      element: 'input',
      type: 'TEXT',
      options: null
    };
  }

  addOption() {
    let index = 0;

    if (this.field.options === null) {
      this.field.options = [];
    }

    if (this.field.options.length) {
      index = this.field.options[this.field.options.length - 1].number;
    }

    this.field.options.push({
      number: index + 1,
      value: null
    });
  }

  removeOption(number) {
    if (number) {
      // reindex
      this.field.options.forEach((option) => {
        if (option.number > number) {
          option.number = option.number - 1;
        }
      });

      this.field.options.splice(number - 1, 1);

      if (!this.field.options.length) {
        this.field.options = null;
      }
    }
  }

  reset() {
    this.field = {
      name: null,
      element: 'input',
      type: 'TEXT',
      options: null
    };
  }

  isSame(arr) {
    let check = false;

    if (arr) {
      for (let i = 0; i < arr.length - 1; i++) {
        if (arr[i + 1] === arr[i]) {
          check = true;
        }
      }
    } else {
      check = false;
    }

    return check;
  }

  process(field) {
    if (field && field.name) {
      this.recipientService.setCustomField(field)
        .then(() => {
          this.reset();
          this.cancel();
        })
        .catch((err) => {
          if (err.status === 409) {
            this.Notification.error(`Det finnes allerede et felt som heter ${field.name}, egendefinerte felter kan ikke ha samme navn.`);
          } else {
            this.Notification.error('Kunne ikke opprette felt');
          }
        });
    } else {
      this.Notification.error('Kunne ikke opprette felt');
    }
  }

  save() {
    let options = null;

    // cleanup options if any
    if (this.field.options !== null) {
      options = [];

      this.field.options.forEach((option) => {
        if (option.value) {
          options.push(option.value);
        }
      });
    }

    let fieldType = this.field.type;
    if (fieldType === 'ENUM') {
      fieldType = 'TEXT';
    }

    let field = {
      name: this.field.name,
      type: fieldType,
      options: options
    };

    if (this.field.type === 'ENUM') {
      if (this.isSame(options)) {
        this.Notification.error('Kunne ikke opprette felt');
      } else {
        this.process(field);
      }
    } else {
      this.process(field);
    }
  }

  cancel() {
    if (this.recipientNumber) {
      // return back to the recipient page
      this.$location.path(`/kunde/${this.recipientNumber}`).search('number', null);
    } else {
      this.$location.path('/egendefinerte-felter');
    }
  }
}

CustomFieldEdit.$inject = ['$location', 'recipientService', 'Notification'];

const customFieldEdit = {
  controller: CustomFieldEdit,
  template: `
    <h2>Definer nytt felt</h2>

    <fieldset>
      <h3 class="subheader">Navn</h3>
      <input type="text" id="name" placeholder="Navn" ng-model="$ctrl.field.name" required autofocus autocomplete="off">
    </fieldset>

    <div class="row">
      <div class="large-6 columns">
        <fieldset>
          <h3 class="subheader">Type</h3>

          <label for="typeText">
            <input type="radio" name="fieldType" id="typeText" ng-model="$ctrl.field.type" value="TEXT" ng-disabled="$ctrl.field.options.length"> Tekst
          </label>
          <label for="typeEnum">
            <input type="radio" name="fieldType" id="typeEnum" ng-model="$ctrl.field.type" value="ENUM" ng-disabled="$ctrl.field.options.length"> Liste
          </label>
          <label for="typeDate">
            <input type="radio" name="fieldType" id="typeDate" ng-model="$ctrl.field.type" value="DATE" ng-disabled="$ctrl.field.options.length"> Dato
          </label>
          <label for="typeNumber">
            <input type="radio" name="fieldType" id="typeNumber" ng-model="$ctrl.field.type" value="NUMBER" ng-disabled="$ctrl.field.options.length"> Tall
          </label>
          <label for="typeCheck" ng-hide="$ctrl.field.element == 'select'">
            <input type="radio" name="fieldType" id="typeCheck" ng-model="$ctrl.field.type" value="BOOLEAN" ng-disabled="$ctrl.field.options.length"> Ja / Nei
          </label>
        </fieldset>
      </div>

      <div class="large-6 columns" ng-show="$ctrl.field.type == 'ENUM'">
        <fieldset>
          <h3 class="subheader">Legg til valg</h3>

          <div ng-repeat="item in $ctrl.field.options | orderBy:item.number.reverse()" class="row collapse">
            <div class="large-11 columns">
              <input type="text" ng-model="item.value" name="option_{{ item.number }}">
            </div>
            <div class="large-1 columns">
              <label class="postfix" ng-click="$ctrl.removeOption(item.number)">
                <i class="fa fa-trash"></i>
              </label>
            </div>
          </div>
          <button ng-click="$ctrl.addOption()" class="button"><i class="fa fa-plus"></i> Legg til</button>
        </fieldset>
      </div>
    </div>

    <fieldset ng-if="$ctrl.field.name && $ctrl.field.type">
      <h3 class="subheader">Forh&aring;ndsvisning</h3>

      <!-- SELECT -->
      <label ng-show="$ctrl.field.options !== null" for="customField_test_1">{{ $ctrl.field.name }}</label>
      <select ng-show="$ctrl.field.options !== null" id="customField_test_1">
        <option ng-repeat="option in $ctrl.field.options" ng-value="option.value">{{ option.value }}</option>
      </select>

      <!-- INPUT text -->
      <label ng-show="$ctrl.field.options == null && $ctrl.field.type != 'BOOLEAN' && $ctrl.field.type != 'ENUM'" for="customField_test_2">{{ $ctrl.field.name }}</label>
      <input ng-show="$ctrl.field.options == null && $ctrl.field.type != 'BOOLEAN' && $ctrl.field.type != 'ENUM'" type="{{ $ctrl.field.type.toLowerCase() || 'text' }}" id="customField_test_2">

      <!-- INPUT checkbox -->
      <label ng-show="$ctrl.field.options == null && $ctrl.field.type == 'BOOLEAN' && $ctrl.field.type != 'ENUM'" for="customField_test_3" class="inline">
        <input ng-show="$ctrl.field.options == null && $ctrl.field.type == 'BOOLEAN' && $ctrl.field.type != 'ENUM'" type="checkbox" id="customField_test_3"> {{ $ctrl.field.name }}
      </label>
    </fieldset>

    <button class="button secondary" ng-click="$ctrl.reset()">Nullstill</button>
    <button class="button" ng-click="$ctrl.save()">Lagre</button>
    <a class="button secondary" role="button" ng-click="$ctrl.cancel()">Avbryt</a>
  `
};

angular
  .module('SendRegning')
  .component('customFieldEdit', customFieldEdit)
  .config(($routeProvider) => {
    $routeProvider
      .when('/egendefinerte-felter/nytt', {
        title: 'Egendefinerte felter',
        template: '<custom-field-edit />',
        secure: true
      });
  });
